import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';

export const sliderBehavior = () => {
  Alpine.data('sliderBehavior', (itemCount = 1) => ({
    slider: undefined,
    init() {
      this.initSlider(itemCount);
    },
    initSlider(count) {
      // On mobile, show one slide at a time as soon as there are 2 or more
      // — that's what puts Splide into an overflowing/carousel state and
      // reveals the arrows and pagination. Desktop caps perPage to the
      // actual item count so the row stays evenly spaced instead of
      // leaving empty space when there are fewer items than a full page,
      // only dropping to a fixed page size once there are more items than
      // fit. The carousel controls only appear once Splide detects the
      // slides overflow the available space.
      const mobilePerPage = 1;
      const desktopPerPage = count <= 4 ? Math.max(1, count) : 4;

      // When sliding one card at a time on mobile, reveal a sliver of the
      // next card so it's clear there's more content to scroll to.
      const mobilePeek = count >= 2 ? { left: 0, right: '2.5rem' } : 0;

      this.slider = new Splide(this.$el, {
        type: 'slide',
        perPage: mobilePerPage,
        perMove: 1,
        gap: '1.5rem',
        padding: mobilePeek,
        pagination: true,
        paginationKeyboard: true,
        arrows: true,
        drag: true,
        keyboard: 'focused',
        mediaQuery: 'min',
        breakpoints: {
          1024: {
            perPage: desktopPerPage,
            gap: '2rem',
            padding: 0,
          },
        },
      });

      this.slider.mount();
    },
  }));
};
